// extracted by mini-css-extract-plugin
module.exports = {"label":"SliderRoundedLabel__label___Dpeug","wrapper":"SliderRoundedLabel__wrapper___1EYWn"};